module.exports = __webpack_public_path__ + "img/XC0705.b9ba5ab5.png";